import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { buildTermsTree } from './terms';
import TreeSelect from '../tree-select';
export default function AuthorSelect(_ref) {
  var label = _ref.label,
      noOptionLabel = _ref.noOptionLabel,
      authorList = _ref.authorList,
      selectedAuthorId = _ref.selectedAuthorId,
      onChange = _ref.onChange;
  if (!authorList) return null;
  var termsTree = buildTermsTree(authorList);
  return createElement(TreeSelect, _extends({
    label: label,
    noOptionLabel: noOptionLabel,
    onChange: onChange
  }, {
    tree: termsTree,
    selectedId: selectedAuthorId
  }));
}
//# sourceMappingURL=author-select.js.map